import { helperFunction } from "../../constant/helper";
import axios from "axios";

import { api } from "../../apis";
import { types } from "../type";

// set loading
const setReportingLoading = (data) => (dispatch) => {
  dispatch({
    type: types.ReportingTypes.REPORTINGS_SET_LOADING,
    payload: data
  });
};

// clear result
const clearReportingResult = () => (dispatch) => {
  dispatch({
    type: types.ReportingTypes.REPORTINGS_CLEAR_RESULT
  });
};

// clear error
const clearReportingErrors = () => (dispatch) => {
  dispatch({
    type: types.ReportingTypes.REPORTINGS_CLEAR_ERRORS
  });
};

// get function
const getFunction = async (url, type, errorType, dispatch) => {
  try {
    const getRequestSuccess = await axios.get(url);
    const { data } = getRequestSuccess;
    dispatch({
      type: type,
      payload: data
    });
    // console.log(data);
  } catch (getRequestError) {
    const errorData = {
      data: getRequestError.response.data,
      status: getRequestError.response.status
    };
    dispatch({
      type: errorType,
      payload: errorData
    });
  }
};

// get reporting managers
const getReportingEmployeesByLocationId = (
  locationId,
  loginType,
  managerId,
  isByManager
) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  let url;
  if (isByManager) {
    url = `${baseUrlNode}${api.Relation_Api.GET_REPORTING_EMPLOYEES_BY_LOCATION_ID_API}/${locationId}/${managerId}`;
  } else {
    url = `${baseUrlNode}${api.Relation_Api.GET_REPORTING_EMPLOYEES_BY_LOCATION_ID_API}/${locationId}`;
  }
  const type =
    types.ReportingTypes.GET_REPORTING_EMPLOYEES_BY_LOCATION_ID;
  const errorType = types.ReportingTypes.REPORTINGS_GET_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

const getReportingManagersByLocationId = (
  locationId,
  loginType
) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Relation_Api.GET_REPORTING_MANAGERS_API}/${locationId}`;
  const type = types.ReportingTypes.GET_REPORTING_MANAGERS;
  const errorType = types.ReportingTypes.REPORTINGS_GET_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

// get  attendance sheet
const getAttendanceSheetReports = (
  fromDate,
  toDate,
  locationId,
  loginType,
  reportingMangerId,
  dataFormat,
  convertByTime,
  sendMail
) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Relation_Api.GET_ATTENDANCE_SHEET_REPORTS_API}/${fromDate}/${toDate}/${locationId}/${reportingMangerId}/${loginType}/${convertByTime}/${sendMail}`;
  const type = types.ReportingTypes.GET_ATTENDANCE_SHEET_REPORTS;
  const errorType = types.ReportingTypes.REPORTINGS_GET_ERRORS;
  dispatch({
    type: types.ReportingTypes.SHEET_INPUTS,
    payload: {
      fromDate,
      toDate,
      locationId,
      dataFormat,
      reportingMangerId,
      convertByTime,
      sendMail
    }
  });
  getFunction(url, type, errorType, dispatch);
};

export {
  setReportingLoading,
  clearReportingResult,
  clearReportingErrors,
  getAttendanceSheetReports,
  getReportingEmployeesByLocationId,
  getReportingManagersByLocationId
};
